import _ from 'lodash';
// import utils from './utils.js';
const gamesDir = require.context('.', true, /\/(config\.js$)/);

let game = [];

gamesDir.keys().forEach((key) => {
  let pageId = parseInt(/[0-9]{1,4}/.exec(/page[0-9]{1,4}/.exec(key)[0])[0]);
  let gameId = /page[0-9]{1,4}_[\w]*[[0-9]{1,2}/.exec(key)[0];

  /** set to base config */
  let gamesBasePath = 'games';

  let gamePath = `static/${gamesBasePath}/${gameId}`;

  game.push(
    _.extend(gamesDir(key).default, {
      id: gameId,
      gamePath: gamePath,
      pageId,
    })
  );
});

export default game;
